export default class Range {
	constructor(el) {
		this.element 		= el;
		this.rangeGroups 	= this.element.querySelectorAll('[rangegroup]');

		this.rangeGroups.forEach((rangeGroup) => {
			const fromSlider 	= rangeGroup.querySelector('[fromslider]');
			const toSlider 		= rangeGroup.querySelector('[toslider]');
			const fromInput 	= rangeGroup.querySelector('[minsize]');
			const toInput 		= rangeGroup.querySelector('[maxsize]');
			const minLabel 		= rangeGroup.querySelector('[minlabel]');
			const maxLabel 		= rangeGroup.querySelector('[maxlabel]');

			// Pinched from Codepen -> https://codepen.io/predragdavidovic/pen/mdpMoWo
			function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
				const [from, to] = getParsed(fromInput, toInput);
				if (from > to) {
					fromSlider.value = to;
					fromInput.value = to;
				} else {
					fromSlider.value = from;
				}
			}

			function controlToInput(toSlider, fromInput, toInput, controlSlider) {
				const [from, to] = getParsed(fromInput, toInput);
				setToggleAccessible(toInput);
				if (from <= to) {
					toSlider.value = to;
					toInput.value = to;
				} else {
					toInput.value = from;
				}
			}

			function controlFromSlider(fromSlider, toSlider, fromInput) {
				const [from, to] = getParsed(fromSlider, toSlider);
				if (from > to) {
					fromSlider.value = to;
					fromInput.value = to;
				} else {
					fromInput.value = from;
				}
			}

			function controlToSlider(fromSlider, toSlider, toInput) {
				const [from, to] = getParsed(fromSlider, toSlider);
				setToggleAccessible(toSlider);
				if (from <= to) {
					toSlider.value = to;
					toInput.value = to;
				} else {
					toInput.value = from;
					toSlider.value = from;
				}
			}

			function getParsed(currentFrom, currentTo) {
				const from = parseInt(currentFrom.value, 10);
				const to = parseInt(currentTo.value, 10);

				if(rangeGroup.hasAttribute('formatnumber')) {
					minLabel.innerHTML = from.toLocaleString();
					maxLabel.innerHTML = to.toLocaleString();
				} else {
					minLabel.innerHTML = from;
					maxLabel.innerHTML = to;
				}

				document.querySelector('[mobilereset]').style.display = 'block';

				return [from, to];
			}

			function setToggleAccessible(currentTarget) {
				if (Number(currentTarget.value) <= 0 ) {
					toSlider.style.zIndex = 2;
				} else {
					toSlider.style.zIndex = 0;
				}
			}
			setToggleAccessible(toSlider);

			fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
			toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
			fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
			toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);
		});
	}

	resetField(rangeGroup) {
		let minLabel 					= rangeGroup.querySelector('[minlabel]');
		let maxLabel 					= rangeGroup.querySelector('[maxlabel]');
		let fromInput 					= rangeGroup.querySelector('[minsize]');
		let toInput 					= rangeGroup.querySelector('[maxsize]');
		let defaultMin 	= rangeGroup.querySelector('[fromslider]').getAttribute('default');
		let defaultMax 	= rangeGroup.querySelector('[toslider]').getAttribute('default');

		minLabel.innerHTML = Number(defaultMin).toLocaleString();
		maxLabel.innerHTML = Number(defaultMax).toLocaleString();

		fromInput.value = defaultMin.toLocaleString();
		toInput.value = defaultMax.toLocaleString();
	}
}
